import ChapterItemComponent from "@common/chapters/ChapterItemComponent"
import NewChapterModal from "@common/chapters/NewChapterModal"
import StudyProgramsFilterList from "@common/chapters/StudyProgramsFilterList"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { IconImageM } from "@common/components/icons/IconsM"
import SelectBox from "@common/components/select/selectSingle-Multiple"
import TextM from "@common/components/text/TextM"
import { PaginatedFlatList } from "@common/screens/PaginatedFlatList"
import { PaginatedFlatListNoNavigation } from "@common/screens/PaginatedFlatListNoNavigation"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { studentClasses } from "@data/constants/formConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { chaptersService } from "@data/services/chaptersService"
import { hasRole } from "@data/utility/ability"
import { findItemInListWithId } from "@data/utility/dataUtils"
import React, { useContext, useRef, useState } from "react"
import { Controller, useController } from "react-hook-form"
import { Dimensions, View } from "react-native"
import { ActivityIndicator, Switch } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import graduate from "../../../assets/icons/menus/graduate.png"
import ServerSearch from "../components/input/ServerSearch"
import StudyProgramChapterSelector from "./StudyProgramChapterSelector"

const SelectChapterScreen = (props) => {
    const { control, goToNextStep, formValues, hasStudyProgram = false, noNavigation = false, onChapterSelect = null, containerWidth = null } = props

    // Choose the right FlatList component based on navigation context
    const ListComponent = noNavigation ? PaginatedFlatListNoNavigation : PaginatedFlatList

    const { field } = useController({
        name: "chapter",
        control,
    })
    const dimensions = useContext(DimensionsContext)

    // Use containerWidth if provided (modal context), otherwise use window dimensions
    const effectiveWidth = containerWidth || Dimensions.get("window").width
    const [urlParams, setUrlParams] = useState({
        school_subject_id: control?._formValues?.subject ?? "",
        search: "",
        class: control?._formValues?.class ?? "",
        student_ids: control?._formValues?.student_ids?.join(",") ?? null,
    })
    const paginatedFlatListRef = useRef()

    const studentId = control?._formValues?.chapter?.studentId ?? null

    const [newChapter, setNewChapter] = useState(
        formValues?.chapter?.new ? formValues?.chapter : null
    )
    const selectedChapter = formValues?.chapter?.new
        ? null
        : control?._formValues?.chapter

    const apiRequest = hasRole(props.user, "student")
        ? chaptersService.getChaptersAsStudent
        : chaptersService.getChaptersAsTutor

    const [visible, setVisible] = useState(false)
    const handleShowModal = () => setVisible(!visible)

    const onSelectChapter = (value) => {
        setNewChapter(null)
        // If onChapterSelect callback is provided, call it directly (bypasses form state timing issue)
        if (onChapterSelect) {
            onChapterSelect(value)
            return
        }
        field.onChange({ ...field?.value, ...value })
        goToNextStep()
    }

    const [useStudyProgram, setUseStudyProgram] = useState(hasStudyProgram)
    const [selectedStudyProgramId, setSelectedStudyProgramId] = useState(null)

    return (
        <View
            style={{
                width: effectiveWidth,
                alignItems: "center",
                flex: 1,
                alignSelf: "center",
            }}
        >
            {hasStudyProgram && (
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        alignSelf: "center",
                        width: effectiveWidth - 40,
                        marginTop: 10,
                        marginBottom: 3,
                    }}
                >
                    <Switch
                        value={useStudyProgram}
                        onValueChange={(value) => {
                            setUseStudyProgram(value)
                            if (value) {
                                setUrlParams({
                                    ...urlParams,
                                    search: "",
                                })
                            } else {
                                setSelectedStudyProgramId(null)
                            }
                        }}
                        color={theme.colors.primary}
                    />
                    <TextM
                        color={theme.colors.primary}
                        fontWeight="Medium"
                        style={{ marginLeft: 8 }}
                    >
                        Mode programme de révision
                    </TextM>
                </View>
            )}
            {useStudyProgram ? (
                <StudyProgramChapterSelector
                    studentIds={control?._formValues?.student_ids?.join(",") ?? studentId}
                    selectedStudyProgramId={selectedStudyProgramId}
                    setSelectedStudyProgramId={setSelectedStudyProgramId}
                    onSelectChapter={onSelectChapter}
                    dimensions={dimensions}
                />
            ) : (
                <>
                    <View
                        style={{
                            width: effectiveWidth - 40,
                            backgroundColor: theme.colors.whiteAlmost,
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <Controller
                                control={control}
                                name="subject"
                                render={({ field: { onChange, value } }) => {
                                    const isEmpty =
                                        value === "" ||
                                        value === undefined ||
                                        value === null

                                    return (
                                        <SelectBox
                                            options={props.schoolSubjects.map(
                                                (x) => {
                                                    return {
                                                        value: x.id.toString(),
                                                        label: x.name,
                                                        icon: x?.icon,
                                                    }
                                                }
                                            )}
                                            value={value}
                                            onSingleSelect={(value) => {
                                                setUrlParams({
                                                    ...urlParams,
                                                    school_subject_id:
                                                        value.value,
                                                })
                                                onChange(value.value)
                                            }}
                                            style={{
                                                flex: 1,
                                                margin: 0,
                                                marginRight: 10,
                                            }}
                                            buttonStyle={{
                                                borderWidth: isEmpty ? 0 : 1,
                                                borderColor:
                                                    theme.colors.lightMore,
                                                borderRadius: theme.roundness,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                paddingHorizontal: 12,
                                                paddingVertical: 4,
                                                backgroundColor: isEmpty
                                                    ? null
                                                    : theme.colors.white,
                                            }}
                                            iconComponent={
                                                value ? (
                                                    <IconImageM
                                                        uri={
                                                            findItemInListWithId(
                                                                value,
                                                                props.schoolSubjects
                                                            )?.icon
                                                        }
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                        width={IS_WEB ? 20 : 14}
                                                    />
                                                ) : (
                                                    <FontAwesome5
                                                        solid
                                                        name="filter"
                                                        size={IS_WEB ? 20 : 14}
                                                        color={
                                                            theme.colors.greyAlt
                                                        }
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                    />
                                                )
                                            }
                                            clearButton
                                            defaultLabel={"Matière"}
                                            valueMode={true}
                                        />
                                    )
                                }}
                            />
                            <Controller
                                control={control}
                                name="class"
                                render={({ field: { onChange, value } }) => {
                                    const isEmpty =
                                        value === "" ||
                                        value === undefined ||
                                        value === null

                                    return (
                                        <SelectBox
                                            options={studentClasses
                                                .map((x) => ({
                                                    label: x,
                                                    value: x,
                                                }))
                                                .slice(0, -1)}
                                            value={value}
                                            onSingleSelect={(value) => {
                                                setUrlParams({
                                                    ...urlParams,
                                                    class: value.value,
                                                })
                                                onChange(value.value)
                                            }}
                                            style={{
                                                flex: 1,
                                                margin: 0,
                                                marginLeft: 10,
                                            }}
                                            buttonStyle={{
                                                borderWidth: isEmpty ? 0 : 1,
                                                borderColor:
                                                    theme.colors.lightMore,
                                                borderRadius: theme.roundness,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                paddingHorizontal: 12,
                                                paddingVertical: 4,
                                                backgroundColor: isEmpty
                                                    ? null
                                                    : theme.colors.white,
                                            }}
                                            iconComponent={
                                                value ? (
                                                    <IconImageM
                                                        source={graduate}
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                        width={IS_WEB ? 20 : 14}
                                                    />
                                                ) : (
                                                    <FontAwesome5
                                                        solid
                                                        name="filter"
                                                        size={IS_WEB ? 20 : 14}
                                                        color={
                                                            theme.colors.greyAlt
                                                        }
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                    />
                                                )
                                            }
                                            clearButton
                                            defaultLabel={
                                                props.user?.profile?.class ??
                                                "Classe"
                                            }
                                            valueMode={true}
                                        />
                                    )
                                }}
                            />
                        </View>
                        <ServerSearch
                            style={{
                                width: effectiveWidth - 40,
                                boxShadow: "none",
                                borderWidth: 1,
                                borderColor: theme.colors.lightMore,
                                margin: 0,
                                marginTop: 4,
                            }}
                            request={
                                props.getChaptersAsStudentRequest ||
                                props.getChaptersAsTutorRequest
                            }
                            urlParams={urlParams}
                            setUrlParams={setUrlParams}
                        />

                        {IS_WEB &&
                            (props.getChaptersAsStudentRequest ||
                                props.getChaptersAsTutorRequest) && (
                                <ActivityIndicator
                                    color={theme.colors.primary}
                                    style={{ marginVertical: 20 }}
                                />
                            )}

                        {newChapter && (
                            <View
                                style={{
                                    marginTop: 20,
                                }}
                            >
                                <TextM fontWeight={"Bold"} fontSize={18}>
                                    {"Nouveau chapitre".toUpperCase()}
                                </TextM>
                                <ChapterItemComponent
                                    chapter={newChapter}
                                    withParentChapter
                                    width={effectiveWidth - 40}
                                    isHighlighted={!selectedChapter?.id}
                                    onPress={() => {
                                        field.onChange(newChapter)
                                        goToNextStep()
                                    }}
                                />
                            </View>
                        )}
                    </View>
                    <ListComponent
                        ref={paginatedFlatListRef}
                        data={props.chapters}
                        noRefreshWhenNoResults={true}
                        contentContainerStyle={{
                            paddingBottom: 100,
                        }}
                        noActivityIndicator
                        additionalOnRefresh={() => {}}
                        additionalRefreshing={false}
                        requestApiService={apiRequest}
                        requestRouteParams={
                            hasRole(props.user, "student")
                                ? null
                                : { id: studentId }
                        }
                        requestUrlParams={urlParams}
                        requestData={null}
                        style={{
                            width: effectiveWidth,
                            flex: 1,
                        }}
                        ListEmptyComponent={
                            props.chapters?.length === 0 && (
                                <>
                                    <TextM
                                        style={{
                                            textAlign: "center",
                                            marginTop: 20,
                                        }}
                                    >
                                        Aucun chapitre trouvé
                                    </TextM>
                                    <FilledButtonM
                                        onPress={() => {
                                            handleShowModal()
                                        }}
                                        icon={"plus"}
                                        style={{
                                            alignSelf: "center",
                                            marginTop: 10,
                                        }}
                                        buttonColor={theme.colors.primary}
                                        textColor={theme.colors.white}
                                        label="Ajouter un chapitre"
                                        mode={"contained"}
                                    />
                                </>
                            )
                        }
                        stickyHeader
                        renderItem={(item) => {
                            const chapterInfos = {
                                ...item.item,
                                ...item?.item?.student_chapters?.[0],
                                studentChapterId: item?.item?.student_chapters?.[0]?.id,
                                id: item?.item?.id,
                            }
                            return (
                                <ChapterItemComponent
                                    chapter={chapterInfos}
                                    key={item.index}
                                    withParentChapter
                                    width={effectiveWidth - 40}
                                    onPress={() => {
                                        // Pass merged chapterInfos to include XP data
                                        onSelectChapter(chapterInfos)
                                    }}
                                    isHighlighted={
                                        selectedChapter?.id === item.item?.id
                                    }
                                />
                            )
                        }}
                    />
                </>
            )}
            {visible && (
                <NewChapterModal
                    handleShowModal={handleShowModal}
                    isOpen={visible}
                    setNewChapter={setNewChapter}
                    onSelectChapter={onSelectChapter}
                    defaultValues={{
                        name: urlParams?.search,
                        school_subject_id: urlParams?.school_subject_id,
                        class: urlParams?.class,
                    }}
                />
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        getChaptersAsStudentRequest: state.api.getChaptersAsStudent?.request,
        getChaptersAsTutorRequest: state.api.getChaptersAsTutor?.request,
        user: state.data.currentUser?.object,
        schoolSubjects: state.data.staticData?.school_subjects,
        maxOngoingChapters: state.data.staticData?.max_ongoing_chapters,
        chapters: state.data?.chapters?.chaptersList,
        liveSessions: state.data.currentUser?.object?.live_sessions,
        liveSessionId: state.liveMode?.liveSessionId,
        isLiveMode: state.liveMode.isLiveModeEnabled,
        studyPrograms: state.data.studyPrograms?.studyPrograms,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectChapterScreen)
